import { render, staticRenderFns } from "./RegisterFooter.vue?vue&type=template&id=a6fcb76a&"
import script from "./RegisterFooter.vue?vue&type=script&lang=js&"
export * from "./RegisterFooter.vue?vue&type=script&lang=js&"
import style0 from "./RegisterFooter.vue?vue&type=style&index=0&id=a6fcb76a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports